<ng-template
  cdkConnectedOverlay
  #connectedOverlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayOrigin]="origin()"
  [cdkConnectedOverlayPositions]="positions()"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="12"
  [cdkConnectedOverlayFlexibleDimensions]="false"
  [cdkConnectedOverlayLockPosition]="false"
  [cdkConnectedOverlayHasBackdrop]="false"
  (overlayOutsideClick)="closed.emit()"
  (attach)="onOverlayAttach(connectedOverlay.overlayRef)"
  (detach)="onOverlayDetach()">
  <div
    class="z-[80] min-w-[12.5rem] rounded-lg border border-primary bg-primary shadow-lg"
    [class]="panelClass()">
    @if (title()) {
      <div class="px-4 pt-3 pb-1 text-sm font-semibold text-primary">
        {{ title() }}
      </div>
    }
    <div class="py-1">
      <ng-content />
    </div>
  </div>
</ng-template>
